import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import FloatLabelInput from "../../../components/FloatingLabel";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import useGetVehicleInfo from "../../../store/selectors/get-vehicle-info";
import { getVehicleInfo } from "../../../utils/backend";
import { Dropdown } from "primereact/dropdown";

const AddOnDrivers = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);

	const selectedAddOn = location.state?.addOn;

	// const initialPlan =
	// 	JSON.parse(localStorage.getItem("plan_code")) ||
	// 	JSON.stringify({ name: "Plan A", code: "Plan A" });

	const [selectedPlan, setSelectedPlan] = useState({name: "PLAN A", code: 'PLAN A'});
	const plans = [
		{ name: "MOTORCYCLIST PA(YOU ONLY)", code: "PA1M", sum_insured: 5000 },
		{ name: "MOTORCYCLIST PA(YOU/RIDER)", code: "PA2M", sum_insured: 10000 },
		{ name: "MCYCLIST PA(YOU/RIDER/PILLION)", code: "PA3M", sum_insured: 15000},
	];

	useEffect(() => {
		console.log('selected plan_a001', selectedPlan)
		localStorage.setItem("plan_code_a001", JSON.stringify(selectedPlan));
	}, [selectedPlan]);

	if (!selectedAddOn) {
		return (
			<div className="content">
				<h3>No Add-on Selected</h3>
				<Button label="Go Back" onClick={() => navigate(-1)} />
			</div>
		);
	}

	const handleReturnClick = (e) => {
		e.preventDefault();
		const queryParameters = new URLSearchParams(window.location.search);
		const policyId = queryParameters.get("policy_id");

		navigate(
			policyId
				? `/get-quote/add-on-others?policy_id=${policyId}`
				: `/get-quote/add-on-others`,
			{
				replace: true,
				state: {
					...selectedAddOn,
					selectedPlan, // Pass the sum_insured value here
				},
			}
		);
	};

	return (
		<div className="content">
			<div className="get-quote-container">
				<h3>{`${selectedAddOn.title}`}</h3>

				<div className="add-on-details border-radius-10 w-100 mb-8rem">
					<Dropdown
						value={selectedPlan}
						onChange={(e) => setSelectedPlan(e.value)}
						options={plans}
						optionLabel="name"
						placeholder="Select a Plan"
						className="w-full md:w-14rem"
					/>
				</div>

				<div className={`sticky-bottom `}>
					<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
						{/* Selected Plan and Logo Section */}
						<div className="plan-details">
							<span className="text-left formatted-text">
								{`Selecting Add-Ons for`}
							</span>
							<br />
							<span className="fw-bold color-heading">
								{selectedAddOn.title}
							</span>
							<p className="my-0 fw-bold insurer-name"></p>
						</div>
						<div className="col-sm-6 w-50"></div>
					</div>
					<hr />
					<Button
						label="Return add-ons"
						className="btn-primary"
						onClick={(e) => handleReturnClick(e)}
					/>
					<BottomMessagePopUp
						message={errorMessage}
						type="error"
						isVisible={isErrorVisible}
						onClose={() => setIsErrorVisible(false)}
					/>
				</div>
			</div>
		</div>
	);
};

export default AddOnDrivers;
